module.exports = __webpack_public_path__ + "static/elwafaapp2-e3bc7ee060063c3221be7c2c9ff7193e.jpg";